import { Routes } from '@angular/router';

import { AuthGuard } from '../../../guards/auth.guard';
import { ExerciseProblemComponent } from './exercise-problem/exercise-problem.component';
import { ExerciseCompleteComponent } from './exercise-complete/exercise-complete.component';
import { ExerciseConcludeComponent } from '../ux/exercise-conclude/exercise-conclude.component';
import { ExerciseIntroComponent } from './exercise-intro/exercise-intro.component';
import {
  ExerciseStrategyTopicComponent
} from './exercise-strategy/exercise-strategy-topic/exercise-strategy-topic.component';
import {
  ExerciseStrategyIdentificationComponent
} from './exercise-strategy/exercise-strategy-identification/exercise-strategy-identification.component';
import {
  ExerciseStrategyHypothesisComponent
} from './exercise-strategy/exercise-strategy-hypothesis/exercise-strategy-hypothesis.component';
import { ExerciseStrategyAnswerComponent } from './exercise-strategy/exercise-strategy-answer/exercise-strategy-answer.component';

export const exerciseRoutes: Routes = [
  {
    path: 'exercise',
    children: [
      {
        path: ':exerciseId',
        children: [

          {
            path: 'intro',
            component: ExerciseIntroComponent,
          },
          {
            path: 'problem',
            component: ExerciseProblemComponent,
            data: {
              problemCase: 'practiceProblem',
            },
          },
          {
            path: 'persistence',
            children: [
              {
                path: '',
                component: ExerciseProblemComponent,
                data: {
                  persistence: true,
                  problemCase: 'persistenceProblem',
                },
              },
              {
                path: 'completed',
                component: ExerciseCompleteComponent,
                data: {
                  persistence: true,
                  problemCase: 'persistenceProblem',
                }
              },
            ]
          },
          {
            path: 'strategy',
            children: [
              {
                path: 'topic',
                component: ExerciseStrategyTopicComponent
              },
              {
                path: 'identification',
                component: ExerciseStrategyIdentificationComponent
              },
              {
                path: 'hypothesis',
                component: ExerciseStrategyHypothesisComponent
              },
              {
                path: 'answer',
                component: ExerciseStrategyAnswerComponent,
                data: {
                  problemCase: 'strategyProblem'
                }
              },
              {
                path: 'completed',
                component: ExerciseCompleteComponent,
                data: {
                  problemCase: 'strategyProblem'
                }
              },
            ]
          },
          {
            path: 'completed',
            component: ExerciseCompleteComponent,
            data: {
              problemCase: 'practiceProblem',
            }
          },
          {
            path: 'conclude',
            component: ExerciseConcludeComponent,
          }],
      }
    ]
  }
];
